import React, { Component } from 'react';
import { Grid, Row, Col, ButtonToolbar, Button, Form, FormGroup, ControlLabel, Checkbox, FormControl, Radio } from 'react-bootstrap';
import { Stage, Layer, Group, Rect, Text, Circle } from 'react-konva';
import { SetOfDayTypesCommand } from '../commands/SetOfDayTypesCommand';
import { HandleMessage } from '../../HandleMessage';
import { LoadingSpinner } from '../../LoadingSpinner';
import Select from "react-select";

export class DayTimesheetDataIdentifier extends Component {
    constructor(props) {
        super(props);

        let stopsListConfiguration = {
            show: false,
            id: props.selectedData || null,
            isDescriptionVerticalOrientation: false,
            showDescription: true,
            showZebraStripes: false,
            descriptionPt: "",
            descriptionEn: "",
            numberColumns: 20,
            startingHour: undefined,
            frequencyType: 0,
            passingOptimizationMethod: 0
        };

        try {
            const parsedConfig = JSON.parse(props.configuration);
            stopsListConfiguration = Object.assign(stopsListConfiguration, parsedConfig);
        } catch (error) { }

        this.state = {
            selectedData: props.selectedData,
            table: {
                data: [],
                loading: true,
            },
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
            },
            form: {
                show: stopsListConfiguration.show,
                id: stopsListConfiguration.id,
                isDescriptionVerticalOrientation: stopsListConfiguration.isDescriptionVerticalOrientation,
                showDescription: stopsListConfiguration.showDescription,
                showZebraStripes: stopsListConfiguration.showZebraStripes,
                descriptionPt: stopsListConfiguration.descriptionPt,
                descriptionEn: stopsListConfiguration.descriptionEn,
                numberColumns: stopsListConfiguration.numberColumns,
                startingHour: stopsListConfiguration.startingHour,
                alternativePassingText: stopsListConfiguration.alternativePassingText,
                frequencyType: stopsListConfiguration.frequencyType,
                passingOptimizationMethod: stopsListConfiguration.passingOptimizationMethod
            },
            actions: {
                isLoading: true,
            },
            commands: {
                setOfDayTypesCommand: new SetOfDayTypesCommand()
            }
        };

        this.getAllData(false);
    }

    getAllData(resetData) {
        if (resetData) {
            const { actions } = this.state;

            actions.isLoading = true;

            this.setState({
                table: {
                    data: [],
                    page: 1,
                    elementsPerPage: 50
                },
                actions: actions
            });
        }

        const { commands } = this.state;

        commands.setOfDayTypesCommand.list(
            (a) => this.successCallback(a),
            (a) => this.errorCallback(a)
        );
    }

    // ---------------------------

    successCallback(result) {
        const { table, actions, form } = this.state;
        const config = result && result.configuration ? JSON.parse(result.configuration) : {};

        actions.isLoading = false;
        table.data = result;

        form.id = result.dataIdentifyer || form.id;
        form.showDescription = config.showDescription !== undefined ? config.showDescription : form.showDescription;
        form.isDescriptionVerticalOrientation = config.isDescriptionVerticalOrientation !== undefined
            ? config.isDescriptionVerticalOrientation
            : form.isDescriptionVerticalOrientation;
        form.showZebraStripes = config.showZebraStripes !== undefined ? config.showZebraStripes : form.showZebraStripes;
        form.descriptionPt = config.descriptionPt !== undefined ? config.descriptionPt : form.descriptionPt;
        form.descriptionEn = config.descriptionEn !== undefined ? config.descriptionEn : form.descriptionEn;
        form.numberColumns = config.numberColumns !== undefined ? Number(config.numberColumns) : form.numberColumns;
        form.startingHour = config.startingHour !== undefined ? Number(config.startingHour) : form.startingHour;
        form.alternativePassingText = config.alternativePassingText !== undefined ? config.alternativePassingText : form.alternativePassingText;
        form.frequencyType = config.frequencyType !== undefined ? config.frequencyType : form.frequencyType;
        form.passingOptimizationMethod = config.passingOptimizationMethod !== undefined ? config.passingOptimizationMethod : form.passingOptimizationMethod;

        this.setState({
            table,
            actions,
            form
        });
    }

    errorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onSelectData(selectedData) {
        const form = this.state;
        form.id = selectedData.value;

        this.setState({
            form,
            selectedData
        });
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeValue(selectedData, target) {
        const { form } = this.state;

        if (selectedData) {
            form[target] = selectedData.value;
        } else {
            form[target] = null;
        }

        this.setState({
            form: form
        });
    }

    onChangeFrequencyType(target, value) {
        const { form } = this.state;
        form[target] = value;

        this.setState({ form });
    }

    onFinishSelectData() {
        const { form } = this.state;
        const data = form.id;

        const configuration = {
            showDescription: form.showDescription,
            isDescriptionVerticalOrientation: form.isDescriptionVerticalOrientation,
            showZebraStripes: form.showZebraStripes,
            descriptionPt: form.descriptionPt,
            descriptionEn: form.descriptionEn,
            numberColumns: form.numberColumns,
            startingHour: form.startingHour,
            alternativePassingText: form.alternativePassingText,
            frequencyType: form.frequencyType,
            passingOptimizationMethod: form.passingOptimizationMethod
        };

        // Trigger save actions
        this.props.onSelectData(data);
        this.props.onConfigureData(JSON.stringify(configuration), true);

        this.setState({
            selectedData: null,
            form: {
                show: false,
                id: null,
                isDescriptionVerticalOrientation: false,
                showDescription: true,
                showZebraStripes: false,
                descriptionPt: "",
                descriptionEn: "",
                numberColumns: 20,
                startingHour: undefined,
                alternativePassingText: "",
                frequencyType: 0,
                passingOptimizationMethod: 0
            },
            styles: {},
        });
    }

    onCancelSelectData() {
        this.setState({
            form: {
                show: false,
                id: 0,
                isDescriptionVerticalOrientation: false,
                showDescription: true,
                showZebraStripes: false,
                descriptionPt: "",
                descriptionEn: "",
                numberColumns: 20
            }
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // -----------------------

    renderSelectedDataDescriptionPt(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        const splitedData = `${selectedData}`.split("|%|");

        if (`${obj.id}` === splitedData[0] && undefined !== splitedData[1]) {
            return (
                <div>{JSON.parse(splitedData[1]).descriptionPt}</div>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSelectedDataDescriptionEn(obj) {
        const { selectedData } = this.state;

        if (null === selectedData || undefined === selectedData) {
            return (
                <div>&nbsp;</div>
            );
        }

        const splitedData = `${selectedData}`.split("|%|");

        if (`${obj.id}` === splitedData[0] && undefined !== splitedData[1]) {
            return (
                <div>{JSON.parse(splitedData[1]).descriptionEn}</div>
            );
        }
        else {
            return (
                <div>&nbsp;</div>
            );
        }
    }

    renderSetsOfDayTypes(isLoading, partialData) {
        const options = partialData.map((obj) => ({
            value: obj.id,
            label: obj.name,
        }));

        const { form } = this.state;

        const selectedOption = options.find(option => option.value === Number(form.id));

        return (
            <div>
                <FormGroup controlId="formSetOfDayTypeText">
                    <ControlLabel>Conjunto Tipo de Dia</ControlLabel>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <Select
                            options={options}
                            placeholder="Conjunto tipo de dia"
                            value={selectedOption}
                            onChange={(e) => this.onChangeValue(e, 'id')}
                            isClearable
                            isSearchable
                        />
                    )}
                </FormGroup>
            </div>
        );
    }

    renderFrequencyType() {
        const { form } = this.state;
        const selected = Number(form.frequencyType);
        const layouts = [];

        for (let i = 0; i < 2; i++) {
            const isSelected = selected === i;

            layouts.push(
                <Col key={i} md={4} sm={6} xs={12}>
                    <Stage width={260} height={60} style={{ cursor: "pointer" }}>
                        <Layer>
                            <Group onClick={() => this.onChangeFrequencyType('frequencyType', i)}>
                                <Rect
                                    x={5}
                                    y={5}
                                    width={250}
                                    height={50}
                                    strokeWidth={isSelected ? 3 : 1}
                                    stroke={isSelected ? "#6699ff" : "#4d4d4d"}
                                    fill="#FFFFFF"
                                />

                                {i === 0 && (
                                    <Text
                                        text="4 / 4 min"
                                        fontSize={14}
                                        align="center"
                                        width={250}
                                        y={22}
                                    />
                                )}

                                {i === 1 && (
                                    <React.Fragment>
                                        <Circle
                                            x={130}
                                            y={30}
                                            radius={15}
                                            stroke="black"
                                            strokeWidth={1}
                                            fill="#FFFFFF"
                                        />
                                        <Text
                                            text="4"
                                            fontSize={14}
                                            x={115}
                                            y={23}
                                            width={30}
                                            align="center"
                                        />
                                    </React.Fragment>
                                )}
                            </Group>
                        </Layer>
                    </Stage>
                </Col>
            );
        }

        return <Grid fluid><Row>{layouts}</Row></Grid>;
    }





    handleFormFieldChange(field) {
        return (e) => {
            const value = e.target.type === "number" ? Number(e.target.value) : e.target.value;
            const updatedForm = this.state.form;
            updatedForm[field] = value;
            this.setState({ form: updatedForm });
        };
    }

    onChangeRadio(target, value) {
        const { form } = this.state;
        form[target] = value;
        this.setState({ form });
    };

    renderTextInput(label, placeholder, value, controlId, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderNumberInput(label, placeholder, value, controlId, min, max, onChange) {
        return (
            <FormGroup controlId={controlId}>
                <ControlLabel>{label}</ControlLabel>
                <FormControl
                    type="number"
                    min={min}
                    max={max}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        );
    }

    renderCheckbox(label, value, onChange, disabled = false, style = {}) {
        return (
            <Checkbox
                checked={value}
                onChange={onChange}
                disabled={disabled}
                style={style}
            >
                {label}
            </Checkbox>
        );
    }

    render() {
        const { form, message, isLoading, table } = this.state;
        return (
            <div>
                <Form>
                    {this.renderSetsOfDayTypes(
                        isLoading,
                        table.data
                    )}

                    {this.renderTextInput(
                        "Descrição PT",
                        "Descrição PT",
                        form.descriptionPt,
                        "formDescriptionPtText",
                        this.handleFormFieldChange("descriptionPt")
                    )}

                    {this.renderTextInput(
                        "Descrição EN",
                        "Descrição EN",
                        form.descriptionEn,
                        "formDescriptionEnText",
                        this.handleFormFieldChange("descriptionEn")
                    )}

                    <FormGroup>
                        {this.renderCheckbox(
                            "Apresentar Descrição",
                            form.showDescription,
                            () => this.onChangeCheckboxValue("showDescription")
                        )}

                        {this.renderCheckbox(
                            "Orientação: Vertical",
                            form.isDescriptionVerticalOrientation,
                            () => this.onChangeCheckboxValue("isDescriptionVerticalOrientation"),
                            !form.showDescription,
                            { marginLeft: "20px" }
                        )}

                        {this.renderCheckbox(
                            "Apresentar Zebras Alternadas",
                            form.showZebraStripes,
                            () => this.onChangeCheckboxValue("showZebraStripes")
                        )}
                    </FormGroup>

                    {this.renderNumberInput(
                        "Número Colunas a Apresentar [1..36]",
                        "Número Colunas a Apresentar",
                        form.numberColumns,
                        "formNumberColumnsText",
                        1,
                        36,
                        this.handleFormFieldChange("numberColumns")
                    )}

                    {this.renderNumberInput(
                        "Primeira Hora a Apresentar [0..23]",
                        "Primeira Hora a Apresentar",
                        form.startingHour,
                        "formStartingHourText",
                        0,
                        23,
                        this.handleFormFieldChange("startingHour")
                    )}

                    {this.renderTextInput(
                        "Mensagem personalizada para horários vazios",
                        "Sem Tempos de Passagem",
                        form.alternativePassingText,
                        "formAlternativePassingText",
                        this.handleFormFieldChange("alternativePassingText")
                    )}

                    <FormGroup>
                        <ControlLabel className="margin-top-15">Tipo de Frequência</ControlLabel>
                        {this.renderFrequencyType()}
                    </FormGroup>
                    <FormGroup>
                        <ControlLabel className="margin-top-15">Método de Optimização das Passagens</ControlLabel>
                        <Radio
                            name="passingOptimizationMethod"
                            checked={form.passingOptimizationMethod === 0}
                            onChange={() => this.onChangeRadio("passingOptimizationMethod", 0)}
                        >
                            Simples
                        </Radio>
                        <Radio
                            name="passingOptimizationMethod"
                            checked={form.passingOptimizationMethod === 1}
                            onChange={() => this.onChangeRadio("passingOptimizationMethod", 1)}
                        >
                            Complexo
                        </Radio>
                        <Radio
                            name="passingOptimizationMethod"
                            checked={form.passingOptimizationMethod === 2}
                            onChange={() => this.onChangeRadio("passingOptimizationMethod", 2)}
                        >
                            Híbrido (complexo nas paragens e simples nas linhas)
                        </Radio>
                    </FormGroup>
                </Form>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onFinishSelectData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>

                <HandleMessage
                    show={message.show}
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    onHide={this.onExitMessage}
                />
            </div>
        );
    }
}